//--------------login flow
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const REFRESH_TOKEN_SUCCESS = "REFRESH_TOKEN_SUCCESS";
export const REFRESH_TOKEN_FAILURE = "REFRESH_TOKEN_FAILURE";

export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const VERIFY_OTP = "VERIFY_OTP";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAILURE = "VERIFY_OTP_FAILURE";

export const CHECK_EMAIL = "CHECK_EMAIL";
export const CHECK_EMAIL_SUCCESS = "CHECK_EMAIL_SUCCESS";
export const CHECK_EMAIL_FAILURE = "CHECK_EMAIL_FAILURE";

export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const LOADER_TRUE = "LOADER_TRUE";
export const LOADER_FALSE = "LOADER_FALSE";
export const TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";

//-------------universities
export const ADD_UNIVERSITY = "ADD_UNIVERSITY";
export const ADD_UNIVERSITY_SUCCESS = "ADD_UNIVERSITY_SUCCESS";
export const ADD_UNIVERSITY_FAILURE = "ADD_UNIVERSITY_FAILURE";

export const ADD_UNIVERSITY_SHEET = "ADD_UNIVERSITY_SHEET";
export const ADD_UNIVERSITY_SHEET_SUCCESS = "ADD_UNIVERSITY_SHEET_SUCCESS";
export const ADD_UNIVERSITY_SHEET_FAILURE = "ADD_UNIVERSITY_SHEET_FAILURE";

export const EDIT_UNIVERSITY = "EDIT_UNIVERSITY";
export const EDIT_UNIVERSITY_SUCCESS = "EDIT_UNIVERSITY_SUCCESS";
export const EDIT_UNIVERSITY_FAILURE = "EDIT_UNIVERSITY_FAILURE";

export const UPLOAD_UNIVERSITY_IMAGES = "UPLOAD_UNIVERSITY_IMAGES";
export const UPLOAD_UNIVERSITY_IMAGES_SUCCESS =
  "UPLOAD_UNIVERSITY_IMAGES_SUCCESS";
export const UPLOAD_UNIVERSITY_IMAGES_FAILURE =
  "UPLOAD_UNIVERSITY_IMAGES_FAILURE";

export const GET_UNIVERSITIES = "GET_UNIVERSITIES";
export const GET_UNIVERSITIES_SUCCESS = "GET_UNIVERSITIES_SUCCESS";
export const GET_UNIVERSITIES_FAILURE = "GET_UNIVERSITIES_FAILURE";

export const GET_UNIVERSITIES_GRID = "GET_UNIVERSITIES_GRID";
export const GET_UNIVERSITIES_GRID_SUCCESS = "GET_UNIVERSITIES_GRID_SUCCESS";
export const GET_UNIVERSITIES_GRID_FAILURE = "GET_UNIVERSITIES_GRID_FAILURE";

export const GET_ALL_UNIVERSITIES = "GET_ALL_UNIVERSITIES";
export const GET_ALL_UNIVERSITIES_SUCCESS = "GET_ALL_UNIVERSITIES_SUCCESS";
export const GET_ALL_UNIVERSITIES_FAILURE = "GET_ALL_UNIVERSITIES_FAILURE";

export const GET_UNIVERSITY_DETAILS = "GET_UNIVERSITY_DETAILS";
export const GET_UNIVERSITY_DETAILS_SUCCESS = "GET_UNIVERSITY_DETAILS_SUCCESS";
export const GET_UNIVERSITY_DETAILS_FAILURE = "GET_UNIVERSITY_DETAILS_FAILURE";

export const GET_UNIVERSITY_DETAILS_ADMIN = "GET_UNIVERSITY_DETAILS_ADMIN";
export const GET_UNIVERSITY_DETAILS_ADMIN_SUCCESS =
  "GET_UNIVERSITY_DETAILS_ADMIN_SUCCESS";
export const GET_UNIVERSITY_DETAILS_ADMIN_FAILURE =
  "GET_UNIVERSITY_DETAILS_ADMIN_FAILURE";

export const GET_UNIS_BY_BUDGET = "GET_UNIS_BY_BUDGET";
export const GET_UNIS_BY_BUDGET_SUCCESS = "GET_UNIS_BY_BUDGET_SUCCESS";
export const GET_UNIS_BY_BUDGET_FAILURE = "GET_UNIS_BY_BUDGET_FAILURE";

export const GET_POPULAR_COUNTRIES = "GET_POPULAR_COUNTRIES";
export const GET_POPULAR_COUNTRIES_SUCCESS = "GET_POPULAR_COUNTRIES_SUCCESS";
export const GET_POPULAR_COUNTRIES_FAILURE = "GET_POPULAR_COUNTRIES_FAILURE";

export const GET_UNI_APPS_SHORTS = "GET_UNI_APPS_SHORTS";
export const GET_UNI_APPS_SHORTS_SUCCESS = "GET_UNI_APPS_SHORTS_SUCCESS";
export const GET_UNI_APPS_SHORTS_FAILURE = "GET_UNI_APPS_SHORTS_FAILURE";

//profile
export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILURE = "GET_PROFILE_FAILURE";

export const EDIT_PROFILE = "EDIT_PROFILE";
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS";
export const EDIT_PROFILE_FAILURE = "EDIT_PROFILE_FAILURE";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

//students
export const GET_ALL_STUDENTS = "GET_ALL_STUDENTS";
export const GET_ALL_STUDENTS_SUCCESS = "GET_ALL_STUDENTS_SUCCESS";
export const GET_ALL_STUDENTS_FAILURE = "GET_ALL_STUDENTS_FAILURE";

export const GET_STUDENTS_ANALYTICS = "GET_STUDENTS_ANALYTICS";
export const GET_STUDENTS_ANALYTICS_SUCCESS = "GET_STUDENTS_ANALYTICS_SUCCESS";
export const GET_STUDENTS_ANALYTICS_FAILURE = "GET_STUDENTS_ANALYTICS_FAILURE";

export const GET_ACTIVE_STUDENTS = "GET_ACTIVE_STUDENTS";
export const GET_ACTIVE_STUDENTS_SUCCESS = "GET_ACTIVE_STUDENTS_SUCCESS";
export const GET_ACTIVE_STUDENTS_FAILURE = "GET_ACTIVE_STUDENTS_FAILURE";

export const GET_STUDENT_DETAILS = "GET_STUDENT_DETAILS";
export const GET_STUDENT_DETAILS_SUCCESS = "GET_STUDENT_DETAILS_SUCCESS";
export const GET_STUDENT_DETAILS_FAILURE = "GET_STUDENT_DETAILS_FAILURE";

export const UPDATE_STUDENT = "UPDATE_STUDENT";
export const UPDATE_STUDENT_SUCCESS = "UPDATE_STUDENT_SUCCESS";
export const UPDATE_STUDENT_FAILURE = "UPDATE_STUDENT_FAILURE";

//meetings
export const ADD_MEETING = "ADD_MEETING";
export const ADD_MEETING_SUCCESS = "ADD_MEETING_SUCCESS";
export const ADD_MEETING_FAILURE = "ADD_MEETING_FAILURE";

export const RESCHEDULE_MEETING = "RESCHEDULE_MEETING";
export const RESCHEDULE_MEETING_SUCCESS = "RESCHEDULE_MEETING_SUCCESS";
export const RESCHEDULE_MEETING_FAILURE = "RESCHEDULE_MEETING_FAILURE";

export const GET_MEETING_DETAILS = "GET_MEETING_DETAILS";
export const GET_MEETING_DETAILS_SUCCESS = "GET_MEETING_DETAILS_SUCCESS";
export const GET_MEETING_DETAILS_FAILURE = "GET_MEETING_DETAILS_FAILURE";

export const GET_MEETINGS = "GET_MEETINGS";
export const GET_MEETINGS_SUCCESS = "GET_MEETINGS_SUCCESS";
export const GET_MEETINGS_FAILURE = "GET_MEETINGS_FAILURE";

export const GET_MEETINGS_INVITES = "GET_MEETINGS_INVITES";
export const GET_MEETINGS_INVITES_SUCCESS = "GET_MEETINGS_INVITES_SUCCESS";
export const GET_MEETINGS_INVITES_FAILURE = "GET_MEETINGS_INVITES_FAILURE";

export const GET_MEETINGS_REQUESTS = "GET_MEETINGS_REQUESTS";
export const GET_MEETINGS_REQUESTS_SUCCESS = "GET_MEETINGS_REQUESTS_SUCCESS";
export const GET_MEETINGS_REQUESTS_FAILURE = "GET_MEETINGS_REQUESTS_FAILURE";

export const GET_UPCOMING_MEETINGS = "GET_UPCOMING_MEETINGS";
export const GET_UPCOMING_MEETINGS_SUCCESS = "GET_UPCOMING_MEETINGS_SUCCESS";
export const GET_UPCOMING_MEETINGS_FAILURE = "GET_UPCOMING_MEETINGS_FAILURE";

export const GET_ALL_MEETINGS_AND_COUNT = "GET_ALL_MEETINGS_AND_COUNT";
export const GET_ALL_MEETINGS_AND_COUNT_SUCCESS =
  "GET_ALL_MEETINGS_AND_COUNT_SUCCESS";
export const GET_ALL_MEETINGS_AND_COUNT_FAILURE =
  "GET_ALL_MEETINGS_AND_COUNT_FAILURE";

export const GET_MEETINGS_BASED_ON_DATE = "GET_MEETINGS_BASED_ON_DATE";
export const GET_MEETINGS_BASED_ON_DATE_SUCCESS =
  "GET_MEETINGS_BASED_ON_DATE_SUCCESS";
export const GET_MEETINGS_BASED_ON_DATE_FAILURE =
  "GET_MEETINGS_BASED_ON_DATE_FAILURE";

export const CHANGE_MEETING_STATUS = "CHANGE_MEETING_STATUS";
export const CHANGE_MEETING_STATUS_SUCCESS = "CHANGE_MEETING_STATUS_SUCCESS";
export const CHANGE_MEETING_STATUS_FAILURE = "CHANGE_MEETING_STATUS_FAILURE";

// time slots
export const GET_TIMESLOTS = "GET_TIMESLOTS";
export const GET_TIMESLOTS_SUCCESS = "GET_TIMESLOTS_SUCCESS";
export const GET_TIMESLOTS_FAILURE = "GET_TIMESLOTS_FAILURE";

export const GET_ALL_TIMESLOTS = "GET_ALL_TIMESLOTS";
export const GET_ALL_TIMESLOTS_SUCCESS = "GET_ALL_TIMESLOTS_SUCCESS";
export const GET_ALL_TIMESLOTS_FAILURE = "GET_ALL_TIMESLOTS_FAILURE";

export const ADD_TIMESLOT = "ADD_TIMESLOT";
export const ADD_TIMESLOT_SUCCESS = "ADD_TIMESLOT_SUCCESS";
export const ADD_TIMESLOT_FAILURE = "ADD_TIMESLOT_FAILURE";

//applications
export const GET_APPLICATIONS = "GET_APPLICATIONS";
export const GET_APPLICATIONS_SUCCESS = "GET_APPLICATIONS_SUCCESS";
export const GET_APPLICATIONS_FAILURE = "GET_APPLICATIONS_FAILURE";

export const GET_APPLICATION_DETAILS = "GET_APPLICATION_DETAILS";
export const GET_APPLICATION_DETAILS_SUCCESS =
  "GET_APPLICATION_DETAILS_SUCCESS";
export const GET_APPLICATION_DETAILS_FAILURE =
  "GET_APPLICATION_DETAILS_FAILURE";

export const CHANGE_APP_STATUS = "CHANGE_APP_STATUS";
export const CHANGE_APP_STATUS_SUCCESS = "CHANGE_APP_STATUS_SUCCESS";
export const CHANGE_APP_STATUS_FAILURE = "CHANGE_APP_STATUS_FAILURE";

export const REQ_LOR = "REQ_LOR";
export const REQ_LOR_SUCCESS = "REQ_LOR_SUCCESS";
export const REQ_LOR_FAILURE = "REQ_LOR_FAILURE";

//notifications
export const ADD_NOTIFICATIONS_SINGLE = "ADD_NOTIFICATIONS_SINGLE";
export const ADD_NOTIFICATIONS_SINGLE_SUCCESS =
  "ADD_NOTIFICATIONS_SINGLE_SUCCESS";
export const ADD_NOTIFICATIONS_SINGLE_FAILURE =
  "ADD_NOTIFICATIONS_SINGLE_FAILURE";

export const ADD_NOTIFICATIONS_MULTIPLE = "ADD_NOTIFICATIONS_MULTIPLE";
export const ADD_NOTIFICATIONS_MULTIPLE_SUCCESS =
  "ADD_NOTIFICATIONS_MULTIPLE_SUCCESS";
export const ADD_NOTIFICATIONS_MULTIPLE_FAILURE =
  "ADD_NOTIFICATIONS_MULTIPLE_FAILURE";

export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS";
export const GET_NOTIFICATIONS_FAILURE = "GET_NOTIFICATIONS_FAILURE";

export const CHANGE_NOTIFICATIONS_STATUS = "CHANGE_NOTIFICATIONS_STATUS";
export const CHANGE_NOTIFICATIONS_STATUS_SUCCESS =
  "CHANGE_NOTIFICATIONS_STATUS_SUCCESS";
export const CHANGE_NOTIFICATIONS_STATUS_FAILURE =
  "CHANGE_NOTIFICATIONS_STATUS_FAILURE";

// chatbot
export const GET_MESSAGES = "GET_MESSAGES";
export const GET_MESSAGES_SUCCESS = "GET_MESSAGES_SUCCESS";
export const GET_MESSAGES_FAILURE = "GET_MESSAGES_FAILURE";

export const GET_UNREAD_MESSAGES = "GET_UNREAD_MESSAGES";
export const GET_UNREAD_MESSAGES_SUCCESS = "GET_UNREAD_MESSAGES_SUCCESS";
export const GET_UNREAD_MESSAGES_FAILURE = "GET_UNREAD_MESSAGES_FAILURE";

export const ADD_MESSAGE = "ADD_MESSAGE";
export const ADD_MESSAGE_SUCCESS = "ADD_MESSAGE_SUCCESS";
export const ADD_MESSAGE_FAILURE = "ADD_MESSAGE_FAILURE";

export const GET_USERS = "GET_USERS";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAILURE = "GET_USERS_FAILURE";

// others
export const GET_DIFF_UNI_VALUES = "GET_DIFF_UNI_VALUES";
export const GET_DIFF_UNI_VALUES_SUCCESS = "GET_DIFF_UNI_VALUES_SUCCESS";
export const GET_DIFF_UNI_VALUES_FAILURE = "GET_DIFF_UNI_VALUES_FAILURE";

export const GET_COUNTRIES = "GET_COUNTRIES";
export const GET_COUNTRIES_SUCCESS = "GET_COUNTRIES_SUCCESS";
export const GET_COUNTRIES_FAILURE = "GET_COUNTRIES_FAILURE";

export const ADD_COUNTRY = "ADD_COUNTRY";
export const ADD_COUNTRY_SUCCESS = "ADD_COUNTRY_SUCCESS";
export const ADD_COUNTRY_FAILURE = "ADD_COUNTRY_FAILURE";

export const EDIT_COUNTRY = "EDIT_COUNTRY";
export const EDIT_COUNTRY_SUCCESS = "EDIT_COUNTRY_SUCCESS";
export const EDIT_COUNTRY_FAILURE = "EDIT_COUNTRY_FAILURE";

export const GET_CONTINENTS = "GET_CONTINENTS";
export const GET_CONTINENTS_SUCCESS = "GET_CONTINENTS_SUCCESS";
export const GET_CONTINENTS_FAILURE = "GET_CONTINENTS_FAILURE";

export const GET_REGIONS = "GET_REGIONS";
export const GET_REGIONS_SUCCESS = "GET_REGIONS_SUCCESS";
export const GET_REGIONS_FAILURE = "GET_REGIONS_FAILURE";

export const GET_ONLINE_USERS = "GET_ONLINE_USERS";
export const GET_ONLINE_USERS_SUCCESS = "GET_ONLINE_USERS_SUCCESS";
export const GET_ONLINE_USERS_FAILURE = "GET_ONLINE_USERS_FAILURE";

export const UPLOAD_IMAGE = "UPLOAD_IMAGE";
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAILURE = "UPLOAD_IMAGE_FAILURE";

export const UPLOAD_FILE = "UPLOAD_FILE";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "UPLOAD_FILE_FAILURE";

export const GET_VISA_INFO = "GET_VISA_INFO";
export const GET_VISA_INFO_SUCCESS = "GET_VISA_INFO_SUCCESS";
export const GET_VISA_INFO_FAILURE = "GET_VISA_INFO_FAILURE";

export const ADD_VISA_INFO = "ADD_VISA_INFO";
export const ADD_VISA_INFO_SUCCESS = "ADD_VISA_INFO_SUCCESS";
export const ADD_VISA_INFO_FAILURE = "ADD_VISA_INFO_FAILURE";

export const EDIT_VISA_INFO = "EDIT_VISA_INFO";
export const EDIT_VISA_INFO_SUCCESS = "EDIT_VISA_INFO_SUCCESS";
export const EDIT_VISA_INFO_FAILURE = "EDIT_VISA_INFO_FAILURE";

export const DELETE_VISA_INFO = "DELETE_VISA_INFO";
export const DELETE_VISA_INFO_SUCCESS = "DELETE_VISA_INFO_SUCCESS";
export const DELETE_VISA_INFO_FAILURE = "DELETE_VISA_INFO_FAILURE";

export const GET_PROGRAM_TYPES = "GET_PROGRAM_TYPES";
export const GET_PROGRAM_TYPES_SUCCESS = "GET_PROGRAM_TYPES_SUCCESS";
export const GET_PROGRAM_TYPES_FAILURE = "GET_PROGRAM_TYPES_FAILURE";

export const GET_PROGRAMS = "GET_PROGRAMS";
export const GET_PROGRAMS_SUCCESS = "GET_PROGRAMS_SUCCESS";
export const GET_PROGRAMS_FAILURE = "GET_PROGRAMS_FAILURE";

export const GET_POPULAR_SUBS = "GET_POPULAR_SUBS";
export const GET_POPULAR_SUBS_SUCCESS = "GET_POPULAR_SUBS_SUCCESS";
export const GET_POPULAR_SUBS_FAILURE = "GET_POPULAR_SUBS_FAILURE";

export const GET_PAYMENT_PLANS = "GET_PAYMENT_PLANS";
export const GET_PAYMENT_PLANS_SUCCESS = "GET_PAYMENT_PLANS_SUCCESS";
export const GET_PAYMENT_PLANS_FAILURE = "GET_PAYMENT_PLANS_FAILURE";

export const GET_TAGS = "GET_TAGS";
export const GET_TAGS_SUCCESS = "GET_TAGS_SUCCESS";
export const GET_TAGS_FAILURE = "GET_TAGS_FAILURE";

// search
export const UNI_SEARCH = "UNI_SEARCH";
export const UNI_SEARCH_SUCCESS = "UNI_SEARCH_SUCCESS";
export const UNI_SEARCH_FAILURE = "UNI_SEARCH_FAILURE";

export const EXPLORE_SEARCH = "EXPLORE_SEARCH";
export const EXPLORE_SEARCH_SUCCESS = "EXPLORE_SEARCH_SUCCESS";
export const EXPLORE_SEARCH_FAILURE = "EXPLORE_SEARCH_FAILURE";

// internships
export const GET_INTERNSHIPS = "GET_INTERNSHIPS";
export const GET_INTERNSHIPS_SUCCESS = "GET_INTERNSHIPS_SUCCESS";
export const GET_INTERNSHIPS_FAILURE = "GET_INTERNSHIPS_FAILURE";

export const UPLOAD_INTERNSHIPS = "UPLOAD_INTERNSHIPS";
export const UPLOAD_INTERNSHIPS_SUCCESS = "UPLOAD_INTERNSHIPS_SUCCESS";
export const UPLOAD_INTERNSHIPS_FAILURE = "UPLOAD_INTERNSHIPS_FAILURE";

export const GET_JOB_COMPANIES = "GET_JOB_COMPANIES";
export const GET_JOB_COMPANIES_SUCCESS = "GET_JOB_COMPANIES_SUCCESS";
export const GET_JOB_COMPANIES_FAILURE = "GET_JOB_COMPANIES_FAILURE";

export const GET_JOB_TYPES = "GET_JOB_TYPES";
export const GET_JOB_TYPES_SUCCESS = "GET_JOB_TYPES_SUCCESS";
export const GET_JOB_TYPES_FAILURE = "GET_JOB_TYPES_FAILURE";

// schools
export const GET_SCHOOLS = "GET_SCHOOLS";
export const GET_SCHOOLS_SUCCESS = "GET_SCHOOLS_SUCCESS";
export const GET_SCHOOLS_FAILURE = "GET_SCHOOLS_FAILURE";

export const GET_SCHOOL = "GET_SCHOOL";
export const GET_SCHOOL_SUCCESS = "GET_SCHOOL_SUCCESS";
export const GET_SCHOOL_FAILURE = "GET_SCHOOL_FAILURE";

export const ADD_SCHOOL = "ADD_SCHOOL";
export const ADD_SCHOOL_SUCCESS = "ADD_SCHOOL_SUCCESS";
export const ADD_SCHOOL_FAILURE = "ADD_SCHOOL_FAILURE";

export const EDIT_SCHOOL = "EDIT_SCHOOL";
export const EDIT_SCHOOL_SUCCESS = "EDIT_SCHOOL_SUCCESS";
export const EDIT_SCHOOL_FAILURE = "EDIT_SCHOOL_FAILURE";

export const CHANGE_SCHOOL_STATUS = "CHANGE_SCHOOL_STATUS";
export const CHANGE_SCHOOL_STATUS_SUCCESS = "CHANGE_SCHOOL_STATUS_SUCCESS";
export const CHANGE_SCHOOL_STATUS_FAILURE = "CHANGE_SCHOOL_STATUS_FAILURE";

// admin
export const GET_DASH_INFO = "GET_DASH_INFO";
export const GET_DASH_INFO_SUCCESS = "GET_DASH_INFO_SUCCESS";
export const GET_DASH_INFO_FAILURE = "GET_DASH_INFO_FAILURE";

export const GET_REG_PER_MONTH = "GET_REG_PER_MONTH";
export const GET_REG_PER_MONTH_SUCCESS = "GET_REG_PER_MONTH_SUCCESS";
export const GET_REG_PER_MONTH_FAILURE = "GET_REG_PER_MONTH_FAILURE";
